export enum DiscountOccurrence {
  CYCLE = 'CYCLE',
  FOREVER = 'FOREVER',
}
